<template>
  <div>
    <el-row :gutter="12">
      <el-col v-for="item in statItems" :key="item.label" :xs="24" :sm="12" :md="8" :lg="6">
        <el-card shadow="hover" style="margin-bottom: 12px;">
          <div style="color: #6b7280; font-size: 13px;">{{ item.label }}</div>
          <div style="margin-top: 8px; font-size: 26px; font-weight: 700;">{{ item.value }}</div>
        </el-card>
      </el-col>
    </el-row>

    <el-card style="margin-top: 12px;">
      <template #header>运营建议</template>
      <el-space wrap>
        <router-link to="/users"><el-button>查看用户列表</el-button></router-link>
        <router-link to="/fortune-ops"><el-button>查看算命转化</el-button></router-link>
      </el-space>
      <div style="margin-top: 12px; color: #6b7280;">建议优先关注新增用户质量与订阅转化漏斗，持续优化算命产品闭环。</div>
    </el-card>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { adminApi } from '../api/admin'

const raw = ref({})

const statItems = computed(() => [
  { label: '用户总数', value: raw.value.users || 0 },
  { label: '消息总数', value: raw.value.messages || 0 }
])

onMounted(async () => {
  try {
    raw.value = await adminApi.overview()
  } catch (e) {
    ElMessage.error(e.message || '加载失败')
  }
})
</script>
